import { render } from "./Categories.vue?vue&type=template&id=20c70aa5&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=20c70aa5&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c70aa5"]])

export default __exports__